export class ListProductCategory {
  constructor(public id: number,
    public name: string,
    public parentCategoryId: number,
    public mainCategoryId: number,
    public sortOrder: number,
    public isActive: boolean) {
  }
}